import(/* webpackMode: "eager" */ "/vercel/path0/app/student/layout.tsx");
